import { useCallback, useEffect, useRef } from "react";
import { convertTimeInput } from "../../utils/convertTimeInput.js";
import { findIndexOfNearestOption } from "../../utils/findIndexOfNearestOption.js";
import { formatTime } from "../../utils/formatTime.js";
function useKeyboardActions(params) {
  const { updateComponentState, timeFormat, options, onBlur, allowEmpty, componentState } = params;
  const componentStateRef = useRef(componentState);
  useEffect(() => {
    componentStateRef.current = componentState;
  }, [componentState]);
  const onKeyDown = useCallback(
    (e) => {
      const { selectValue } = componentStateRef.current;
      const validCodes = ["ArrowDown", "ArrowUp", "Enter", "Escape", "Tab"];
      if (!validCodes.includes(e.code)) return;
      let selectedIndex = options.findIndex((item) => item === selectValue);
      const inputElement = e.target;
      switch (e.code) {
        case "Tab":
          updateComponentState({
            open: false
          });
          break;
        case "Escape":
          e.preventDefault();
          updateComponentState({
            open: false,
            inputValue: componentStateRef.current.timeValue ? formatTime(componentStateRef.current.timeValue, timeFormat) : ""
          });
          break;
        case "Enter":
          e.preventDefault();
          if (selectedIndex !== -1) {
            inputElement.select();
            updateComponentState({
              open: false,
              timeValue: options[selectedIndex],
              selectValue: options[selectedIndex],
              inputValue: formatTime(options[selectedIndex], timeFormat)
            });
          } else {
            onBlur();
          }
          break;
        case "ArrowUp":
          e.preventDefault();
          if (selectedIndex < 0) {
            const convertedInputValue = convertTimeInput(componentStateRef.current.inputValue, timeFormat, allowEmpty);
            if (convertedInputValue !== "invalid" && convertedInputValue !== null) {
              const nearestIndex = findIndexOfNearestOption(convertedInputValue, options);
              if (nearestIndex) {
                selectedIndex = nearestIndex;
              }
            }
          }
          if (selectedIndex <= 0) {
            updateComponentState({ open: true });
          } else {
            updateComponentState({
              open: true,
              selectValue: options[selectedIndex - 1],
              inputValue: formatTime(options[selectedIndex - 1], timeFormat)
            });
          }
          break;
        case "ArrowDown":
          e.preventDefault();
          if (selectedIndex < 0) {
            const convertedInputValue = convertTimeInput(componentStateRef.current.inputValue, timeFormat, allowEmpty);
            if (convertedInputValue !== "invalid" && convertedInputValue !== null) {
              const nearestIndex = findIndexOfNearestOption(convertedInputValue, options);
              if (nearestIndex) {
                selectedIndex = nearestIndex;
              }
            }
          }
          if (selectedIndex >= options.length - 1) {
            updateComponentState({ open: true });
          } else {
            updateComponentState({
              open: true,
              selectValue: options[selectedIndex + 1],
              inputValue: formatTime(options[selectedIndex + 1], timeFormat)
            });
          }
          break;
      }
    },
    [updateComponentState, options, timeFormat, onBlur, allowEmpty]
  );
  return { onKeyDown };
}
export {
  useKeyboardActions
};
//# sourceMappingURL=useKeyboardActions.js.map
